import { useState } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { ScrollBarIcon } from '@icons/ScrollbarIcon';
import { CloseIcon } from '@icons/CloseIcon';

const Container = tw.div`absolute bottom-[24px] right-[24px] flex flex-col items-center justify-center w-[356px] h-[126px] text-risk-unrelated-light px-6 py-4 rounded-lg z-30 transition-all duration-300`;
const Title = tw.div`text-sm font-bold mt-[10px] mb-[2px] uppercase`;
const Description = tw.div`text-xs font-medium text-center`;
const CloseButton = tw.div`absolute top-3 right-4 w-3 h-3 cursor-pointer`;

export const TABLE_SCROLL_TIP_KEY = 'table-scroll-tip';

export const TableScrollTip = () => {
  const { t } = useTranslation();
  const [isClosed, setIsClosed] = useState(false);
  const isShown = localStorage.getItem(TABLE_SCROLL_TIP_KEY);
  if (isShown) return null;

  const handleClose = () => {
    localStorage.setItem(TABLE_SCROLL_TIP_KEY, 'true');
    setIsClosed(true);
  };

  return (
    <Container
      css={{
        background: 'rgba(59, 61, 74, 0.8)',
        filter: 'drop-shadow(2px 18px 37px rgba(0, 0, 0, 0.2))',
        backdropFilter: 'blur(8px)',
        border: 'border: 1px solid rgba(59, 61, 74, 0.5)',
        height: isClosed ? 0 : '126px',
        opacity: isClosed ? 0 : 1,
      }}>
      <ScrollBarIcon />
      <Title>{t('insights.show_details_drawer.table_scroll_tip.title')}</Title>
      <Description>{t('insights.show_details_drawer.table_scroll_tip.description')}</Description>

      <CloseButton onClick={handleClose}>
        <CloseIcon fill='#E7EDF7' />
      </CloseButton>
    </Container>
  );
};
